module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', _vm._b({
    attrs: {
      "disabled": _vm.isDisabled,
      "loading": _vm.isLoading,
      "size": _vm.size
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'el-button', _vm.$attrs, false), [_c('span', {
    staticClass: "rt-button-text"
  }, [(_vm.iconName) ? _c('rt-icon', {
    attrs: {
      "name": _vm.iconName,
      "size": _vm.iconSize
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1498375c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/button/rtButton.vue
// module id = 1399
// module chunks = 116